<template>
  <div class="current-order-item">
    <b-container class="bv-example-row">
      <b-row>
        <b-col><img :src="item.image" alt=""></b-col>
        <b-col>{{ item.commonName }}<br>{{ item.name }}</b-col>
        <b-col>{{ item.norm }}</b-col>
        <b-col>{{ item.maker }}</b-col>
        <b-col>{{ item.licenseNumber }}</b-col>
        <b-col>{{ item.largeScale }}</b-col>
        <b-col>{{ item.lotNumber }}</b-col>
        <b-col>{{ item.expiryTime }}</b-col>
        <b-col>{{ item.basicUnit }}</b-col>
        <b-col>{{ item.showPrice }}</b-col>
        <b-col>{{ item.num }}</b-col>
        <b-col>{{ item.count }}</b-col>
        <b-col>
          <a href="javasccript:void(0)" class="download">下载</a>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
    }
  },
  created () {
    console.log(this.item, 'this items')
  }
}
</script>
<style>
  .current-order-item img {
    max-width: 30px;
  }
  .current-order-item .row {
    border-bottom: 3px solid #f8b551;
    background-color: #f5f5f5;
    flex-wrap: nowrap;
    display: table;
  }
  .current-order-item .col {
    flex-basis: auto;
    padding: 0;
    display: table-cell;
    height: 40px;
    line-height: 18px;
    vertical-align: middle;
    font-weight: normal;
  }
  .current-order-item .col a {
    text-decoration: none;
    color:#34e51c;
  }
  .current-order-item .col:nth-of-type(1) {
    width: 50px;
    text-align: center;
  }
  .current-order-item .col:nth-of-type(2) {
    width: 140px;
  }
  .current-order-item .col:nth-of-type(3) {
    width: 70px;
  }
  .current-order-item .col:nth-of-type(4) {
    width: 120px;
  }
  .current-order-item .col:nth-of-type(5) {
    width: 100px;
  }
  .current-order-item .col:nth-of-type(6) {
    width: 80px;
  }
  .current-order-item .col:nth-of-type(7) {
    width: 90px;
  }
  .current-order-item .col:nth-of-type(8) {
    width: 100px;
  }
  .current-order-item .col:nth-of-type(9) {
    width: 50px;
  }
  .current-order-item .col:nth-of-type(10) {
    width: 80px;
  }
  .current-order-item .col:nth-of-type(11) {
    width: 100px;
  }
  .current-order-item .col:nth-of-type(12) {
    width: 80px;
  }
  .current-order-item .col:nth-of-type(13) {
    width: 140px;
  }
</style>
